import React from 'react';
import Badge from '../ui/Badge';

/**
 * Section Header component with optional badge, title, and subtitle
 * Alignment options: left, center
 */
const SectionHeader = ({
  badge,
  title,
  subtitle,
  alignment = 'center',
  className = '',
}) => {
  const alignmentClasses = {
    left: 'text-left',
    center: 'text-center',
  };
  
  const containerClasses = {
    left: '',
    center: 'mx-auto max-w-3xl',
  };
  
  return (
    <div className={`${containerClasses[alignment]} ${className}`}>
      {badge && (
        <div className={`mb-4 ${alignment === 'center' ? 'flex justify-center' : ''}`}>
          <Badge variant="outline" className="inline-block">
            {badge}
          </Badge>
        </div>
      )}
      
      {title && (
        <h2 className={`text-3xl md:text-5xl font-extrabold mb-4 tracking-tight ${alignmentClasses[alignment]}`} style={{ color: 'var(--text-primary)' }}>
          {title}
        </h2>
      )}
      
      {subtitle && (
        <p className={`text-base md:text-lg leading-relaxed ${alignmentClasses[alignment]}`} style={{ color: 'var(--text-muted)' }}>
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionHeader;
